export const TAB_QUERY_NAME = "active";
